export default __webpack_public_path__ + "static/media/ic_buscar_precios.835970df.svg";